
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as assetConstants from '../../constants/assets';
import SORT from '../../enums/Sort';

import { Select, MenuItem, withStyles } from '@material-ui/core';

const SortingView = ({
    classes,
    order,
    orderDirection,
    bucketId,
    application,
    onOrderChange,
    onOrderDirectionChange,
    fetchAssets,
}) => {
    const onOrderChanged = (e) => {
        onOrderChange(e.target.value);
        fetchAssets(bucketId, application);
    }

    const onOrderDirectionChanged = (e) => {
        onOrderDirectionChange(e.target.value);
        fetchAssets(bucketId, application);
    }

    const orderItems = SORT.ORDER.map((order) => {
        const value = typeof order.value === 'string' ? order.value : order.value[application];
        return (
            <MenuItem key={value} value={value}>
                {order.label}
            </MenuItem>
        );
    });

    const directionItems = SORT.DIRECTION.map((direction) => (
        <MenuItem key={direction.value} value={direction.value}>
            {direction.label}
        </MenuItem>
    ));

    return (
        <div className={classes.sortWrapper}>
            <Select
                value={order}
                className={classes.sortTrigger}
                disableUnderline
                onChange={onOrderChanged}
            >
                {orderItems}
            </Select>
            <Select
                value={orderDirection}
                className={classes.sortTrigger}
                disableUnderline
                onChange={onOrderDirectionChanged}
            >
                {directionItems}
            </Select>
        </div>
    );
};

const style = () => ({
    sortWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        maxWidth: '980px',
        marginBottom: '10px',
    },
    sortTrigger: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        height: '24px',
        fontWeight: 'bold',
        width: 'auto',
        color: 'rgba(0, 0, 0, 0.48)',
        marginRight: '10px',
    },
});

SortingView.propTypes = {
    order: PropTypes.string.isRequired,
    orderDirection: PropTypes.string.isRequired,
    bucketId: PropTypes.number.isRequired,
    application: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
    order: state.assets.order,
    orderDirection: state.assets.orderDirection,
    bucketId: state.assets.bucketId,
    application: state.assets.application,
});

const mapDispatchToProps = (dispatch) => ({
    onOrderChange: (order) => dispatch({
        type: assetConstants.SET_ASSET_ORDER,
        payload: { order },
    }),
    onOrderDirectionChange: (orderDirection) => dispatch({
        type: assetConstants.SET_ASSET_ORDER_DIRECTION,
        payload: { orderDirection },
    }),
    fetchAssets: (bucketId, application) => {
        dispatch({
            type: assetConstants.FETCH_ASSETS_REQUEST,
            payload: { bucketId, application },
        });
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(style)(SortingView));



// WEBPACK FOOTER //
// ./src/components/sorting/SortingView.js